import { cn } from "~/common/shadcn-utils"

export const Divider = ({ className }: { className?: string }) => (
  <div className={cn("bg-gray-E6E6E3 h-[1px]", className)} />
)
